import React from 'react';
import './Services.css';

const Services = () => {
  const servicesData = [
    {
      id: '01',
      title: 'Market Entry & Incorporation',
      description: 'Comprehensive asset management solutions for optimal portfolio performance.',
      isDetailed: false
    },
    {
      id: '02',
      title: 'FDI Advisory & RBI Compliance',
      description: 'IoT-enabled manufacturing solutions for Industry 4.0 transformation.',
      isDetailed: false
    },
    {
      id: '03',
      title: 'Finance & Accounting',
      description: 'Become faster, more flexible, and intensely customer-focused.',
      isDetailed: true
    },
    {
      id: '04',
      title: 'Audit & Assurance',
      description: 'Strategic investment solutions and capital management services.',
      isDetailed: false
    },
    {
      id: '05',
      title: 'Taxation & Regulatory Compliance',
      description: 'Advanced risk assessment and mitigation strategies.',
      isDetailed: false
    },
    {
      id: '06',
      title: 'Human Resources & Payroll',
      description: 'Expert guidance through complex M&A transactions.',
      isDetailed: false
    },
    {
      id: '07',
      title: 'Legal & Corporate Compliance',
      description: 'End-to-end digital transformation for modern enterprises.',
      isDetailed: false
    },
    {
      id: '08',
      title: 'Intellectual Property & Cyber Law',
      description: 'Strategic financial planning and investment advisory services.',
      isDetailed: true
    }
  ];

  const handleServiceClick = (serviceTitle) => {
    console.log(`Clicked on ${serviceTitle}`);
    // Add your navigation logic here
  };

  return (
    <section className="services-section">
      <div className="container">
        <div className="services-header">
          <h2 className="services-title2">Services We Provide</h2>
        </div>
        
        <div className="services-grid">
          {/* Row 1 */}
          <div className="service-row">
            <div 
              className="service-card service-card-1"
              onClick={() => handleServiceClick(servicesData[0].title)}
            >
              <div className="service-overlay">
                <span className="service-number">{servicesData[0].id}</span>
                <h3 className="service-title">{servicesData[0].title}</h3>
                <p className="service-description service-description-mobile">
                  {servicesData[0].description}
                </p>
                 <a 
                  href="/ourservicesdetail" 
                  className="learn-more"
                  onClick={(e) => e.stopPropagation()}
                >
                  Learn More →
                </a>
              </div>
            </div>
            <div 
              className="service-card service-card-2"
              onClick={() => handleServiceClick(servicesData[1].title)}
            >
              <div className="service-overlay">
                <span className="service-number">{servicesData[1].id}</span>
                <h3 className="service-title">{servicesData[1].title}</h3>
                <p className="service-description service-description-mobile">
                  {servicesData[1].description}
                </p>
                 <a 
                  href="ourservicesdetail2" 
                  className="learn-more"
                  onClick={(e) => e.stopPropagation()}
                >
                  Learn More →
                </a>
              </div>
            </div>
            <div 
              className="service-card service-card-3"
              onClick={() => handleServiceClick(servicesData[2].title)}
            >
              <div className="service-overlay">
                <span className="service-number">{servicesData[2].id}</span>
                <h3 className="service-title">{servicesData[2].title}</h3>
                <p className="service-description">
                  {servicesData[2].description}
                </p>

                <a 
                  href="ourservicesdetail3" 
                  className="learn-more"
                  onClick={(e) => e.stopPropagation()}
                >
                  Learn More →
                </a>
              </div>
            </div>
          </div>

          {/* Row 2 */}
          <div className="service-row">
            <div 
              className="service-card service-card-4"
              onClick={() => handleServiceClick(servicesData[3].title)}
            >
              <div className="service-overlay">
                <span className="service-number">{servicesData[3].id}</span>
                <h3 className="service-title">{servicesData[3].title}</h3>
                <p className="service-description service-description-mobile">
                  {servicesData[3].description}
                </p>
                 <a 
                  href="ourservicesdetail4" 
                  className="learn-more"
                  onClick={(e) => e.stopPropagation()}
                >
                  Learn More →
                </a>
              </div>
            </div>
            <div 
              className="service-card service-card-5"
              onClick={() => handleServiceClick(servicesData[4].title)}
            >
              <div className="service-overlay">
                <span className="service-number">{servicesData[4].id}</span>
                <h3 className="service-title">{servicesData[4].title}</h3>
                <p className="service-description service-description-mobile">
                  {servicesData[4].description}
                </p>
                 <a 
                  href="ourservicesdetail5" 
                  className="learn-more"
                  onClick={(e) => e.stopPropagation()}
                >
                  Learn More →
                </a>
              </div>
            </div>
            <div 
              className="service-card service-card-6"
              onClick={() => handleServiceClick(servicesData[5].title)}
            >
              <div className="service-overlay">
                <span className="service-number">{servicesData[5].id}</span>
                <h3 className="service-title">{servicesData[5].title}</h3>
                <p className="service-description service-description-mobile">
                  {servicesData[5].description}
                </p>
                 <a 
                  href="ourservicesdetail6" 
                  className="learn-more"
                  onClick={(e) => e.stopPropagation()}
                >
                  Learn More →
                </a>
              </div>
            </div>
          </div>

          {/* Row 3 */}
          <div className="service-row">
            <div 
              className="service-card service-card-7"
              onClick={() => handleServiceClick(servicesData[6].title)}
            >
              <div className="service-overlay">
                <span className="service-number">{servicesData[6].id}</span>
                <h3 className="service-title">{servicesData[6].title}</h3>
                <p className="service-description service-description-mobile">
                  {servicesData[6].description}
                </p>
                 <a 
                  href="ourservicesdetail7" 
                  className="learn-more"
                  onClick={(e) => e.stopPropagation()}
                >
                  Learn More →
                </a>
              </div>
            </div>
            <div 
              className="service-card service-card-8"
              onClick={() => handleServiceClick(servicesData[7].title)}
            >
              <div className="service-overlay">
                <span className="service-number">{servicesData[7].id}</span>
                <h3 className="service-title">{servicesData[7].title}</h3>
                <p className="service-description">
                  {servicesData[7].description}
                </p>
                <a 
                  href="ourservicesdetail8" 
                  className="learn-more"
                  onClick={(e) => e.stopPropagation()}
                >
                  Learn More →
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;